import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Helmet } from "react-helmet";

const Touch = () => {
  const form = useRef();
  const [load, setLoad] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();
    setLoad(true);
    emailjs
      .sendForm("service_dkb26gp", "template_z5v546f", form.current, {
        publicKey: "_OcrEm-PrH92Amhwc",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          form.current.reset();
          setLoad(false);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setLoad(false);
        }
      );
  };

  return (
    <>
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="title" content="Contact - Pal Kagrecha" />

          <meta
            name="description"
            content="Reach out to Pal Kagrecha and explore the possibilities of innovative Augmented Reality solutions. Contact our team for inquiries, collaborations, or to discuss how we can elevate your projects with our expertise in AR technology."
          />
          <meta
            name="keywords"
            content="Augmented Reality, AR experiences, Innovation, Digital Transformation, Pal Kagrecha, Expertise, Story, Values, Team, Technology"
          />
          <meta property="og:title" content="Contact - Pal Kagrecha" />
          <meta
            property="og:description"
            content="Reach out to Pal Kagrecha and explore the possibilities of innovative Augmented Reality solutions. Contact our team for inquiries, collaborations, or to discuss how we can elevate your projects with our expertise in AR technology."
          />
          <meta property="og:url" content="https://palkagrecha.com/contact" />
          <meta
            property="og:image"
            itemprop="image"
            content="https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/wmgts7znbrnfgbgeubev"
          />
          <link rel="canonical" href="https://www.palkagrecha.com/contact" />
          <meta name="author" content="Pal Kagrecha" />
          <title> Contact - Pal Kagrecha</title>
        </Helmet>
      </div>
      <div className="touch">
        <div className="container">
          <div className="row">
            <div className="col-6 mt-3 responsiveContact">
              <div className="row touchForm">
                <h2>
                  <b>Get in touch</b>
                </h2>
                <div className="row">
                  <form ref={form} onSubmit={sendEmail}>
                    <div className="mb-1 formHeadingLabel">
                      <label for="exampleInputName" class="form-label">
                        Your Name
                      </label>
                      <input
                        name="user_name"
                        type="text"
                        className="form-control"
                        id="exampleInputName"
                        required
                      />
                    </div>

                    <div className="mb-1 formHeadingLabel">
                      <label for="exampleInputEmail1" class="form-label">
                        Email address
                      </label>
                      <input
                        type="email"
                        name="user_email"
                        className="form-control"
                        id="exampleInputEmail1"
                        required
                      />
                    </div>
                    {/* <div className="mb-1 formHeadingLabel">
                      <label for="exampleInputAddress" class="form-label">
                        Your Address
                      </label>
                      <input
                        type="text"
                        name="address"
                        className="form-control"
                        id="exampleInputAddress"
                      />
                    </div> */}
                    <div className="mb-1 formHeadingLabel">
                      <label for="exampleInputPhone" class="form-label">
                        Your Phone No
                      </label>
                      <input
                        type="number"
                        name="user_phone"
                        className="form-control"
                        id="exampleInputPhone"
                      />
                    </div>
                    <div className="mb-1 formHeadingLabel">
                      <label for="exampleFormControlMessage" class="form-label">
                        Message
                      </label>
                      <textarea
                        name="message"
                        className="form-control"
                        id="exampleFormControlMessage"
                        rows="3"
                        required
                      ></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary">
                      {load ? "Loading..." : "Submit"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Touch;
